import { Prisma, PrismaClient, users } from '@prisma/client';
import { DefaultArgs } from '@prisma/client/runtime/library';

export interface Coupon {
  id: string;
  object: string;
  amount_off: null;
  applies_to?: { products: string[] };
  created: number;
  currency: null;
  duration: string;
  duration_in_months: null;
  livemode: boolean;
  max_redemptions: null;
  metadata: any[];
  name: string;
  percent_off: number;
  redeem_by: null;
  times_redeemed: number;
  valid: boolean;
}

export const trialActive = (user?: users | null) => {
  return user?.subscription_status === 'trialing';
};

export const getUserAssetDownloadCount = async (
  userId: number,
  prisma: PrismaClient<Prisma.PrismaClientOptions, never, DefaultArgs>
) => {
  const result = await prisma.$queryRawUnsafe<[{ total_downloads: number }]>(
    `
      SELECT
          SUM(
              CASE
                  WHEN e.event IN ('Downloaded photo(s)', 'Downloaded photo', 'Downloaded Video', 'Downloaded clip')
                      THEN 1
                  WHEN e.event = 'Downloaded Photo Pack'
                      THEN (
                          SELECT COUNT(*)
                          FROM photos p
                          WHERE p.pack_id = e.pack_id
                      )
                  WHEN e.event = 'Downloaded Video Pack'
                      THEN (
                          SELECT COUNT(*)
                          FROM clips c
                          WHERE c.pack_id = e.pack_id
                      )
                  ELSE 0
              END
          ) AS total_downloads
      FROM events e
      WHERE e.user_id = ?
        AND e.event IN (
              'Downloaded photo(s)',
              'Downloaded photo',
              'Downloaded Photo Pack',
              'Downloaded Video',
              'Downloaded clip',
              'Downloaded Video Pack'
        );
    `,
    userId
  );

  const totalDownloads = result[0]?.total_downloads ?? 0;
  return totalDownloads;
};
